<!-- <div style="background-image: ('../../../assets/images/notfound.png')"> -->
<!-- <div [ngStyle]="{background: 'url()'}"></div> -->
<!-- <img src="../../../assets/images/notfound.png"> -->
<div class="image"></div>
<!-- <div [ngStyle]="{background: 'url(./images/' + trls.img + ')'}"></div> -->